import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
  iconButton: {
    position: 'relative',
  },
});
